
<div class="row" *ngIf="initialData else noInitialDataTemplate">
    <div class="col-12 button-bar">
        <span class="link cursor-pointer" (click)="initialData = undefined">Annuler cette analyse</span>
    </div>
    <div class="col-12 col-lg-10 col-xl-9" style="text-align: center;">
        <img src="{{initialData.image}}" style="max-width: 100%;"/>
    </div>
    <div class="col-12 col-lg-2 col-xl-3">
        <ng-container *ngIf="initialData.pressureLocation as pressureLocation">
            <div class="d-flex w-100 m-y-12" style="border: 1px solid black;">
                <div class="text-center flex-grow-1">
                    <h1>Gauche</h1>
                    <h5>{{(pressureLocation.topLeft + pressureLocation.bottomLeft) | number:'1.2-2'}} %</h5>
                </div>
                <div class="text-center flex-grow-1" style="border-left: 1px solid black">
                    <h1>Droite</h1>
                    <h5>{{(pressureLocation.topRight + pressureLocation.bottomRight) | number:'1.2-2'}} %</h5>
                </div>
            </div>
            <div class="d-flex w-100 m-y-12 flex-col" style="border: 1px solid black;">
                <div class="text-center flex-grow-1">
                    <h1>Avant</h1>
                    <h5>{{(pressureLocation.top) | number:'1.2-2'}} %</h5>
                </div>
                <div class="text-center flex-grow-1" style="border-top: 1px solid black">
                    <h1>Arrière</h1>
                    <h5>{{(pressureLocation.bottom) | number:'1.2-2'}} %</h5>
                </div>
            </div>
            <div class="d-flex w-100 m-y-12 flex-wrap" style="border: 1px solid black;">
                <div class="text-center flex-grow-1" style="flex-basis: 50%; border-bottom: 1px solid black;">
                    <h1>Q1</h1>
                    <h5>{{(pressureLocation.topLeft) | number:'1.2-2'}} %</h5>
                </div>
                <div class="text-center flex-grow-1" style="flex-basis: 50%; border-left: 1px solid black; border-bottom: 1px solid black;">
                    <h1>Q2</h1>
                    <h5>{{(pressureLocation.topRight) | number:'1.2-2'}} %</h5>
                </div>
                <div class="text-center flex-grow-1" style="flex-basis: 50%;">
                    <h1>Q3</h1>
                    <h5>{{(pressureLocation.bottomLeft) | number:'1.2-2'}} %</h5>
                </div>
                <div class="text-center flex-grow-1" style="flex-basis: 50%; border-left: 1px solid black;">
                    <h1>Q4</h1>
                    <h5>{{(pressureLocation.bottomRight) | number:'1.2-2'}} %</h5>
                </div>
            </div>
        </ng-container>
    </div>
</div>
<ng-template #noInitialDataTemplate>
    <app-materialize-plate-exam-static
            [value]="initialData"
            (dataChangedEvent)="onChanged($event)"></app-materialize-plate-exam-static>
</ng-template>

